import Joi from "joi-browser";
import TestDriveRequestCreate from "../TestDriveRequestCreate";

class TestDriveRequestEdit extends TestDriveRequestCreate {
  schema = { ...this.schema, id: Joi.number().required() };

  componentDidMount = () => {
    this.populateTestDriveRequest();
  };

  populateTestDriveRequest = async () => {
    try {
      const id = this.props.match.params.id;
      const { data: testDriveRequest } = await this.testDriveRequestHelper.findOne(
        `${this.apiPath}/${id}`
      );
      console.log("testDriveRequest", testDriveRequest);

      this.setState({ data: this.mapToViewTestDriveRequest(testDriveRequest) });

      console.log('arrived here');
    } catch (ex) {
      console.log("ex", ex);

      if (ex.response && ex.response.status === 404) {
        return this.props.history.replace("/404");
      }
    }
  };

  doSubmit = async () => {
    console.log("Submitted");

    const id = this.props.match.params.id;
    await this.testDriveRequestHelper.update(`${this.apiPath}/${id}`, this.state.data);
    this.props.history.replace("/test_drive_requests");
  };

  mapToViewTestDriveRequest = (testDriveRequest) => {
    return {
      id: testDriveRequest.id,
      firstName: testDriveRequest.firstName,
      lastName: testDriveRequest.lastName,
      email: testDriveRequest.email,
      telephone: testDriveRequest.telephone,
      zipCode: testDriveRequest.zipCode,
      acceptedMarketingActivity: testDriveRequest.acceptedMarketingActivity,
    };
  };
}

export default TestDriveRequestEdit;
